/**
 * A short trail of what happened before a failure.
 *
 * Sentry breadcrumbs already do this, but they only exist *inside* Sentry — a report that leaves by
 * email has to carry its own. Route changes, requests and a handful of named actions, no payloads.
 */

export interface TrailEntry {
  at: string;
  type: 'route' | 'request' | 'action';
  label: string;
  status?: number;
  ms?: number;
}

/** Long enough to show how the user got here, short enough to paste into an email. */
const MAX_ENTRIES = 25;

const entries: TrailEntry[] = [];

export const pushTrail = (entry: Omit<TrailEntry, 'at'>): void => {
  try {
    entries.push({ ...entry, at: new Date().toISOString() });
    if (entries.length > MAX_ENTRIES) {
      entries.splice(0, entries.length - MAX_ENTRIES);
    }
  } catch {
    // A trail is a nicety; never let recording one break the thing being recorded.
  }
};

/** A copy, so a report cannot be mutated by later activity while it is being submitted. */
export const readTrail = (): TrailEntry[] => entries.slice();

export const clearTrail = (): void => {
  entries.length = 0;
};
